import { createContext, useContext } from "react";


export interface InitialStateType {
  endpoint: string;
  blankAppUrl: string;
  sharedGreaseFormUrl: string;
  oneOffDischargeFormUrl: string;
  termsConditionsUrl: string;
  legalUrl: string;
  moreInformationUrl: string;
  emailAddress: string;
  menus: any[];
  plumbingPlans: any[];
}

// used to create context for linters, not required but it helps development
export const initialState: InitialStateType = {
  endpoint: '',
  blankAppUrl: '',
  sharedGreaseFormUrl: '',
  oneOffDischargeFormUrl: '',
  termsConditionsUrl: '',
  legalUrl: '',
  moreInformationUrl: '',
  emailAddress: '',
  menus: [],
  plumbingPlans: []
};


// reducer accepts a type identifier and a payload which it adds to state
export const reducer = (
  state: InitialStateType,
  { type, payload }: { type: string; payload: any }
): InitialStateType => {
  switch (type) {
    case "addMenu": {
      return {
        ...state,
        menus: [...state?.menus, payload.upload]
      };
    }
    case "addPlumbingPlan": {
      return {
        ...state,
        plumbingPlans: [...state?.plumbingPlans, payload.upload],
      };
    }

    case "removeMenu": {
      return {
        ...state,
        menus: state?.menus.filter(menu => menu.id !== payload.id),
      };
    }
    case "removePlan": {
      return {
        ...state,
        plumbingPlans: state?.plumbingPlans.filter(plan => plan.id !== payload.id),
      };
    }
    case "deleteUploads": {
      return {
        ...state,
        menus: [],
        plumbingPlans: []
      };
    }
    default:
      return state;
  }
};
// initialState is the default state when no state is provided
reducer.defaultProps = {
  state: initialState,
};

const TradeWasteContext = createContext<any>(initialState);

export default TradeWasteContext

// const [state, dispatch] = useTradeWasteContext()
export const useTradeWasteContext = () => useContext(TradeWasteContext);